const getClosestTo = (ref, values) => {
	let closestValue = null;
	let lowestGap = null;
	values.forEach(value => {
		const gap = Math.abs(ref - value);
		if (lowestGap == null || gap < lowestGap) {
			lowestGap = gap;
			closestValue = value;
		}
	});
	return closestValue;
};

export default class WheelCursor {
	constructor(total, current) {
		this.total = total;
		this.current = current;
	}
	setOnIndex(index) {
		const currentTurn = this.getCurrentTurn();
		const normalComposed = this.getComposed(index, currentTurn);
		const lowerComposed = this.getComposed(index, currentTurn - 1);
		const higherComposed = this.getComposed(index, currentTurn + 1);
		const nextIndex = getClosestTo(this.current, [
			normalComposed,
			lowerComposed,
			higherComposed,
		]);
		this.current = nextIndex;
		return nextIndex;
	}
	getCurrentTurn() {
		return Math.floor(this.current / this.total);
	}
	getSlice() {
		return Math.abs(
			this.current >= 0
				? this.current % this.total
				: (this.total + (this.current % this.total)) % this.total,
		);
	}
	getComposed(index, turn) {
		return index + turn * this.total;
	}
}
